export default "__VITE_ASSET__rp$qlsH1__"